import { render, staticRenderFns } from "./CustomersBalanceReportTable.vue?vue&type=template&id=09104aaf"
import script from "./CustomersBalanceReportTable.vue?vue&type=script&lang=js"
export * from "./CustomersBalanceReportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports